import React, { useState, useEffect } from 'react';
import './ShootGame.css';

function ShootGame() {
    const [targetPosition, setTargetPosition] = useState({ top: '50%', left: '50%' });
    const [score, setScore] = useState(0);

    const moveTarget = () => {
        const newTop = Math.random() * 100 + '%';
        const newLeft = Math.random() * 100 + '%';
        setTargetPosition({ top: newTop, left: newLeft });
    };

    useEffect(() => {
        const interval = setInterval(moveTarget, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleClick = () => {
        setScore(score + 1);
        moveTarget();
    };
    const openUrl = () => {
        window.open('https://draftj.in', '_blank');
    }

    return (
        <div className="App">
            Try to click on red ball 
            <br/>  <br/>  <br/>  <br/>  <br/>  <br/>  <br/>  <br/>  <br/>  <br/>  <br/>
            <div className="target" style={targetPosition} onClick={handleClick}></div>
            <div className="score">Score: {score}
            <p>
            <button onClick={openUrl}>Home</button>
            </p>
            </div>
        </div>
    );
}

export default ShootGame;
